import { ALTERAR_DETALHAMENTO_ROTA, BUSCAR_ROTAS } from '../../actions/types'

const initialState = undefined

export default function reducerRotas (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ROTAS: {
      const rotas = action.payload.data;

      if (rotas) {
        return rotas
      }
      return []
    }

    case ALTERAR_DETALHAMENTO_ROTA: {
      const rota = action.payload;
      const objeto = state.rotas.filter(it => rota.id === it.id)[0];
      const indice = state.rotas.indexOf(objeto);
      const novaRota = Object.assign({}, objeto, { exibirDetalhe: !objeto.exibirDetalhe });
      const novo = [...state.rotas];
      novo[indice] = novaRota;
      return {
        ...state,
        rotas: novo
      };
    }

    default: {
      return state
    }
  }
}
